import { render } from "./ProductDetailsCard.vue?vue&type=template&id=1ffcdb7a&scoped=true"
import script from "./ProductDetailsCard.vue?vue&type=script&lang=js"
export * from "./ProductDetailsCard.vue?vue&type=script&lang=js"

import "./ProductDetailsCard.vue?vue&type=style&index=0&id=1ffcdb7a&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffcdb7a"]])

export default __exports__